import styled from 'styled-components';

export const Container = styled.div`
  margin: 30px auto;
  max-width: 80vw;

@media only screen and (max-width: 600px) {
    max-width: 100vw;
    width: 90%;
}
`;

export const Title = styled.h1`
    color: white;
    font-weight: bold;
    text-align: center;
`;

export const Description = styled.p`
    color: white;
    font-weight: normal;
    text-align: center;
    letter-spacing: 0.1em;
`;

export const Content = styled.p`
    color: white;
    font-weight: lighter;
    text-align: center;
    letter-spacing: 0.1em;
    line-spacing: 1px;
    max-width: 100%;
`;

export const NewLine = styled.br``;


export const Point = styled.b`
    font-weight: bold;
`;